<template>
  <div>
    <toast-notification ref="notification" />
    <loading-spinner
      ref="spinner"
      spinnerType="border"
      color="primary"
    ></loading-spinner>
    <site-modal
      ID="chooseClientModal"
      modalSize="semiMedium"
      :showCloseButton="false"
      modalHeaderClass="bg-gray-700 text-yellowTheme"
      modalFooterClass="border-0 p-0 m-0 d-none"
    >
      <template #header>
        <div class="row">
          <h6>
            <svg
              width="18px"
              height="18px"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              class="bi bi-person-check-fill ms-2"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M15.854 5.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L12.5 7.793l2.646-2.647a.5.5 0 0 1 .708 0z"
              ></path>
              <path
                d="M1 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
              ></path>
            </svg>
            انتخاب شناسه کاربری
          </h6>
        </div>
      </template>
      <template #body>
        <div>مایل هستید با کدام حساب کاربری ادامه دهید؟</div>
        <div class="row">
          <div
            class="col-6 p-0 m-0 px-4 py-2"
            v-for="item in loginResponseViewModel?.clients"
            :key="item.personID"
          >
            <div
              class="card shadow text-center bg-gray-200 pointer transition-hover-bottom"
              @click="this.chooseClientButtonClick(item)"
            >
              <div class="card-body">
                <!-- <svg
                  width="30px"
                  height="30px"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  class="bi bi-person-check"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H1s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C9.516 10.68 8.289 10 6 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z"
                  ></path>
                  <path
                    fill-rule="evenodd"
                    d="M15.854 5.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L12.5 7.793l2.646-2.647a.5.5 0 0 1 .708 0z"
                  ></path>
                </svg> -->
                <div>{{ item.firstName }} {{ item.lastName }}</div>
                <!-- <div title="شماره عضویت" class="pointer">
                {{ item.clientCode }}
              </div> -->
              </div>
            </div>
          </div>
        </div>
      </template>
      <template #footer>
        <div class=""></div>
      </template>
    </site-modal>

    <site-modal
      ID="privacyModal"
      modalSize="medium"
      @Closed="closePrivacyModal"
    >
      <template #header>
        <h6>شرایط ارگانیک مایندد و قوانین حریم خصوصی</h6>
      </template>
      <template #body>
        <div>
          <p class="justified">
            به وب‌سایت رسمی کلینیک روان‌شناسی و روان‌پزشکی ارگانیک مایندد خوش
            آمدید.
          </p>
          <p class="justified">
            ما در ارگانیک مایندد متعهد به ارائه خدمات درمانی، مشاوره‌ای و
            ارزیابی روان‌شناختی با بالاترین استانداردهای علمی، اخلاقی و حرفه‌ای
            هستیم. استفاده از این وب‌سایت و دریافت هرگونه خدمات به منزله‌ی پذیرش
            کامل مفاد زیر است.
          </p>
          <p class="justified">1. محدوده خدمات</p>
          <p class="justified">
            کلینیک ارگانیک مایندد خدمات متنوعی را به مراجعان داخل و خارج از کشور
            ارائه می‌دهد، از جمله:
          </p>
          <ul>
            <li>روان‌درمانی فردی، زوجی، خانوادگی و گروهی</li>
            <li>مشاوره روان‌پزشکی و تنظیم دارو</li>
            <li>
              انجام تست‌های روان‌سنجی، ارزیابی‌های نوروسایکولوژیک و مصاحبه‌های
              تشخیصی
            </li>
            <li>
              برگزاری دوره‌های آموزشی، کارگاه‌های رشد فردی و برنامه‌های ارتقای
              سلامت روان
            </li>
          </ul>
          <p class="justified">
            تمامی خدمات روانشناختی توسط متخصصان مجرب، آموزش‌دیده و دارای مجوز
            رسمی از سازمان نظام روانشناسی و مشاوه کشور ارائه می‌گردند.
          </p>

          <p class="justified">۲. شرایط رزرو و لغو جلسات</p>
          <ul>
            <li>
              دریافت خدمات صرفاً از طریق رزرو قبلی از طریق وب‌سایت یا تماس با
              واحد پذیرش امکان‌پذیر است.
            </li>
            <li>
              هر جلسه رواندرمانی به‌طور معمول بین ۴۵ تا ۵۰ دقیقه به طول
              می‌انجامد. این زمان برای جلسات روانپزشکی ۱۵ دقیقه تعریف شده است.
            </li>
            <li>
              در صورت نیاز به لغو یا تغییر زمان جلسه، مراجع موظف است حداقل ۴۸
              ساعت پیش از زمان رزرو‌شده به کلینیک اطلاع دهد. عدم رعایت این بازه،
              منجر به کسر کامل هزینه جلسه خواهد شد.
            </li>
            <li>
              تأخیر بیش از ۱۵ دقیقه بدون اطلاع قبلی، به‌منزله لغو جلسه تلقی
              می‌شود و قابل جبران نخواهد بود.
            </li>
          </ul>
          <p class="justified">۳. محرمانگی اطلاعات و حریم خصوصی</p>
          <p class="justified">
            ما متعهدیم که اطلاعات شما را با بالاترین سطح امنیت و محرمانگی
            نگهداری کنیم. سیاست‌های حفظ حریم خصوصی ما مطابق با استانداردهای
            جهانی تدوین شده‌اند.
          </p>
          <p class="justified">۳.۱ اطلاعات جمع‌آوری‌شده</p>
          <p class="justified">
            ما ممکن است اطلاعات زیر را از شما دریافت و ذخیره کنیم:
          </p>
          <ul>
            <li>اطلاعات شناسایی و تماس (نام، ایمیل، شماره تلفن)</li>
            <li>اطلاعات روان‌شناختی، تشخیصی و درمانی</li>
            <li>
              اطلاعات مربوط به استفاده از سایت (آی‌پی، نوع مرورگر، کوکی‌ها)
            </li>
          </ul>
          <p class="justified">۳.۲ هدف از جمع‌آوری اطلاعات</p>
          <ul>
            <li>ارائه خدمات تخصصی و شخصی‌سازی‌شده</li>
            <li>بهبود کیفیت خدمات درمانی و آموزشی</li>
            <li>تسهیل ارتباطات اداری و درمانی با مراجعان</li>
          </ul>

          <p class="justified">۳.۳ شیوه حفاظت از اطلاعات</p>
          <ul>
            <li>
              استفاده از سرورهای امن، رمزنگاری داده‌ها و محدود کردن دسترسی به
              اطلاعات فقط برای اعضای مرتبط
            </li>
            <li>آموزش مستمر تیم درمان و پشتیبانی برای رعایت محرمانگی</li>
            <li>
              عدم اشتراک‌گذاری اطلاعات با شخص ثالث، مگر با رضایت صریح شما یا در
              موارد الزامی قانونی
            </li>
          </ul>
          <p class="justified">۴. عدم افشای اطلاعات (Non-Disclosure Policy)</p>
          <p class="justified">
            کلینیک ارگانیک مایندد به‌طور کامل متعهد به حفظ رازداری در قبال
            اطلاعات مراجعان است:
          </p>
          <ul>
            <li>
              هیچ اطلاعاتی – اعم از پرونده درمانی، محتوای جلسات یا مکاتبات –
              بدون رضایت مکتوب و آگاهانه مراجع در اختیار شخص یا نهاد ثالثی قرار
              نمی‌گیرد.
            </li>
            <li>
              استثنا تنها در مواردی‌ست که خطر جدی برای فرد یا دیگران وجود داشته
              باشد، یا قانون، افشای اطلاعات را الزامی کرده باشد (مثلاً
              سوءاستفاده از کودک یا حکم قضایی).
            </li>
            <li>
              تمامی کارکنان و درمانگران کلینیک، موافقت‌نامه رسمی محرمانگی
              اطلاعات (NDA) را امضا کرده‌اند و مسئولیت هرگونه تخطی، متوجه شخص
              خاطی خواهد بود.
            </li>
            <li>
              زیرساخت‌های ارتباطی کلینیک (ایمیل، فرم‌ها، واتس‌اپ و…) فقط توسط
              افراد مجاز بررسی و مدیریت می‌شوند.
            </li>
          </ul>

          <p class="justified">۵. خدمات بین‌المللی و حفاظت از داده‌های جهانی</p>
          <p class="justified">
            ارگانیک مایندد با افتخار خدمات خود را به فارسی‌زبانان ساکن خارج از
            کشور نیز ارائه می‌دهد:
          </p>
          <ul>
            <li>
              جلسات برای مراجعان بین‌المللی به زبان فارسی یا انگلیسی برگزار
              می‌شود.
            </li>
            <li>
              برنامه‌ریزی جلسات بر اساس ساعت رسمی تهران (IRST) انجام می‌شود.
              لطفاً هنگام رزرو، اختلاف زمانی را مدنظر قرار دهید.
            </li>
            <li>
              داده‌های مراجعان خارج از ایران با رعایت کامل قوانین GDPR (اروپا)،
              HIPAA (آمریکا) و سایر استانداردهای جهانی حفاظت از داده‌ها نگهداری
              می‌شود.
            </li>
            <li>
              اطلاعات مراجعان بین‌المللی بدون رضایت کتبی، در اختیار هیچ سازمان،
              دولت یا نهاد ثالثی قرار نخواهد گرفت.
            </li>
          </ul>
          <p class="justified">
            برای رزرو جلسه از خارج از کشور، لطفاً از طریق واتس‌اپ با ما در تماس
            باشید: <span class="ms-2" dir="ltr">+98 903 130 9156</span>
          </p>

          <p class="justified">۶. مسئولیت مراجع و رضایت آگاهانه</p>
          <p class="justified">
            با استفاده از این وب‌سایت یا دریافت هرگونه خدمات، شما:
          </p>
          <ul>
            <li>
              با کلیه مفاد این سند به‌ صورت آگاهانه و داوطلبانه موافقت می‌کنید.
            </li>
            <li>
              مسئولیت ارائه اطلاعات دقیق، تعامل شفاف با درمانگر و رعایت
              توصیه‌های تخصصی را بر عهده می‌گیرید.
            </li>
            <li>
              حق دارید روند درمان را در هر زمان متوقف کنید یا درخواست تغییر
              درمانگر داشته باشید.
            </li>
            <li>
              می‌توانید اطلاعات خود را بازبینی، اصلاح یا درخواست حذف آن را ارائه
              دهید.
            </li>
          </ul>
          <p class="justified">۷. موارد فوریتی و محدودیت خدمات</p>
          <ul>
            <li>
              خدمات این کلینیک برای مسائل غیرفوریتی طراحی شده‌اند. در صورت وجود
              بحران روانی یا خطر فوری، لطفاً با اورژانس محل سکونت خود تماس
              بگیرید.
            </li>
            <li>
              ارگانیک مایندد خدمات ۲۴ ساعته، فوریت روان‌پزشکی یا بستری ارائه
              نمی‌دهد.
            </li>
            <li>
              نسخه‌نویسی دارویی فقط برای مراجعانی انجام می‌شود که توسط روان‌پزشک
              کلینیک به‌ صورت مستقیم ارزیابی شده‌اند.
            </li>
          </ul>

          <p class="justified">
            کلینیک ارگانیک مایندد؛ همراهی علمی، انسانی و پایدار برای سلامت روان
            و کیفیت زندگی.
          </p>
          <p class="justified">
            برای هرگونه پرسش یا دریافت اطلاعات بیشتر، با ما از طریق راه‌های
            ارتباطی درج‌ شده در بخش پشتیبانی در تماس باشید.
          </p>
        </div>
      </template>
      <template #footer>
        <div class="m-auto">
          <button
            class="btn btn-sm rounded btn-blueSite"
            @click="closePrivacyModal"
          >
            <i class="fi fi-check"></i>
            تایید
          </button>
        </div>
      </template>
    </site-modal>

    <div class="section py-4">
      <div class="px-2 max-w-800 mx-auto text-center">
        <!-- <div>ورود یا ثبت نام در ارگانیک مایندد</div> -->
      </div>
    </div>

    <!-- ---------------------------------------- -->
    <div class="section pt-1 my-3" v-if="status == 'login'">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-sm-9 col-md-9 col-lg-5">
            <div
              novalidate=""
              action="#"
              class="bs-validate rounded border shadow-xs"
            >
              <div class="p-1 border border-bottom">
                <!-- ........................ enterPhoneEmail .................. -->
                <div v-if="loginState == 'enterPhoneEmail'">
                  <p
                    class="text-center alert alert-success px-1"
                    :class="isMobile ? 'fs13px' : ''"
                  >
                    جهت ثبت نوبت، گزینه مناسب را انتخاب و تکمیل نمایید
                  </p>
                  <div class="p-3">
                    <div class="p-2 mb-2 rounded">
                      <div class="form-check mb-2">
                        <input
                          class="form-check-input form-check-input-success"
                          type="radio"
                          name="loginRadioPhoneEmail"
                          id="loginRadioPhone"
                          @click="loginRadioClick"
                          :checked="radiologinPhoneEmail == 'phone'"
                        />
                        <label class="form-check-label" for="loginRadioPhone">
                          ساکن ایران هستم
                        </label>
                      </div>

                      <input-with-message
                        ref="phoneEmailLoginInput"
                        containerClass="mb-3"
                        errorMessage="وارد کردن شماره موبایل الزامی است"
                        erroMessageClass="text-danger smaller"
                        topTitle=""
                        inputPlaceHolder="لطفا شماره موبایل خود را وارد نمایید"
                        inputType="text"
                        :showMessage="false"
                        input-class="active p-3"
                        v-if="radiologinPhoneEmail == 'phone'"
                        v-model:inputValue="
                          checkPhoneEmailForLoginEntity.phoneEmail
                        "
                      />
                    </div>

                    <div class="p-2 mb-2 rounded">
                      <div class="form-check mb-2">
                        <input
                          class="form-check-input form-check-input-success"
                          type="radio"
                          name="loginRadioPhoneEmail"
                          id="loginRadioEmail"
                          @click="loginRadioClick"
                          :checked="radiologinPhoneEmail == 'email'"
                        />
                        <label class="form-check-label" for="loginRadioEmail">
                          خارج از ایران سکونت دارم
                        </label>
                      </div>

                      <input-with-message
                        ref="phoneEmailLoginInput"
                        containerClass="mb-3"
                        errorMessage="وارد کردن آدرس ایمیل الزامی است"
                        erroMessageClass="text-danger smaller"
                        topTitle=""
                        inputPlaceHolder="لطفا آدرس ایمیل خود را وارد نمایید"
                        inputType="text"
                        :showMessage="false"
                        input-class="active p-3"
                        v-if="radiologinPhoneEmail == 'email'"
                        v-model:inputValue="
                          checkPhoneEmailForLoginEntity.phoneEmail
                        "
                      />
                    </div>

                    <button
                      class="btn btn-blueSite w-100"
                      @click="checkPhoneEmailLoginClick"
                    >
                      <span>تایید</span>
                    </button>
                  </div>
                </div>
                <!-- ........................ chooseLoginMethod .................. -->
                <div v-if="loginState == 'chooseLoginMethod'">
                  <p class="text-center alert alert-success">
                    نحوه ورود را انتخاب نمایید
                  </p>
                  <div class="row p-4 mt-4">
                    <div class="col-6">
                      <button
                        class="btn btn-blueSite w-100"
                        :class="isMobile ? 'fs14px' : ''"
                        @click="enterWithOTPClick"
                      >
                        <span>رمز یکبار مصرف</span>
                      </button>
                    </div>
                    <div class="col-6">
                      <button
                        class="btn btn-blueSite w-100"
                        :class="isMobile ? 'fs14px' : ''"
                        @click="enterWithPassClick"
                      >
                        <span>رمز ثابت</span>
                      </button>
                    </div>
                  </div>
                </div>
                <!-- ............................ Login With OTP ............................. -->
                <div v-if="loginState == 'enterWithOTP'">
                  <p class="text-center alert alert-success">
                    کد اعتبار سنجی ارسال شده را وارد نمایید
                  </p>
                  <div class="card-body px-4">
                    <div dir="ltr">
                      <code-input
                        ref="confirmationCodeInput"
                        id="confirmationCodeInput"
                        @complete="onOtpComplete"
                        :fields="6"
                        :fieldWidth="isMobile ? 42 : 56"
                        :fieldHeight="isMobile ? 42 : 56"
                        :required="true"
                        title=""
                        errorMessage="وارد کردن کد اعتبار سنجی الزامی است"
                        erroMessageClass="px-4 smaller text-danger"
                        titleClass="pe-3"
                      />
                    </div>

                    <div class="row mt-3">
                      <div class="col-6">
                        <button
                          type="submit"
                          class="btn btn-blueSite w-100"
                          @click="verifyOTPForLogin"
                        >
                          <i class="fi fi-box-checked"></i>
                          ورود
                        </button>
                      </div>
                      <div class="col-6">
                        <div class="text-center">
                          <button
                            class="btn btn-blueSite w-100"
                            :disabled="otpCounting"
                            @click="resendOTPClick"
                          >
                            <vue-countdown
                              v-if="otpCounting"
                              :time="125000"
                              @end="onOTPCountdownEnd"
                              v-slot="{ minutes, seconds }"
                              :transform="transformSlotProps"
                            >
                              {{ minutes }}:{{ seconds }}
                            </vue-countdown>
                            <span v-else>ارسال کد</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- ............................... Login With Pass ......................................                 -->
                <div v-if="loginState == 'enterWithPass'">
                  <p class="text-center alert alert-success">
                    رمز عبور ثابت خود را وارد نمایید
                  </p>
                  <div class="p-4">
                    <floating-input-with-message
                      containerClass="mb-1"
                      inputType="password"
                      ID="login_password"
                      ref="login_password"
                      inputPlaceHolder="کلمه عبور"
                      v-model:inputValue="entity.password"
                      labelClass="text-muted small"
                      labelValue="کلمه عبور"
                      errorMessage="وارد کردن کلمه عبور الزامی است"
                      erroMessageClass="smaller text-danger"
                    />
                    <div class="form-floating mb-1">
                      <captcha ref="captchaComp" :display="failLogin >= 3">
                      </captcha>
                    </div>
                    <div class="row mt-0">
                      <div class="col-12 text-start fs13px mt-0">
                        <a @click="resetPassShowClick" class="pointer"
                          >رمز عبور را فراموش کرده اید؟</a
                        >
                      </div>
                    </div>

                    <div class="row mt-3 g-3 justify-content-center">
                      <div class="col-6">
                        <button class="btn btn-blueSite w-100" @click="login">
                          ورود
                        </button>
                      </div>
                      <!-- <div class="col-6">
                        <div class="text-center">
                          <button
                            class="btn btn-blueSite w-100"
                            @click="resetPassShowClick"
                          >
                            <span>فراموشی رمز عبور</span>
                          </button>
                        </div>
                      </div> -->
                    </div>
                  </div>
                </div>

                <div
                  class="mt-3"
                  @click="loginReturnButtonClick"
                  v-if="loginState != 'enterPhoneEmail'"
                >
                  <p class="px-4">
                    <a href="#" class="text-decoration-none link-muted fs13px"
                      ><i class="fi fi-arrow-right"></i>
                      بازگشت
                    </a>
                  </p>
                </div>
              </div>
            </div>

            <div
              class=""
              v-if="
                isMobile &&
                (loginState == 'enterPhoneEmail' ||
                  loginState == 'chooseLoginMethod')
              "
            >
              <a
                class="btn btn-link text-secondary p-0 mt-3 fs15px"
                data-bs-toggle="collapse"
                href="#collapseExample"
                role="button"
                aria-expanded="false"
                aria-controls="collapseExample"
              >
                <svg
                  width="18px"
                  height="18px"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  class="bi bi-headset"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M8 1a5 5 0 0 0-5 5v1h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a6 6 0 1 1 12 0v6a2.5 2.5 0 0 1-2.5 2.5H9.366a1 1 0 0 1-.866.5h-1a1 1 0 1 1 0-2h1a1 1 0 0 1 .866.5H11.5A1.5 1.5 0 0 0 13 12h-1a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h1V6a5 5 0 0 0-5-5z"
                  ></path>
                </svg>
                پشتیبانی
                <i class="fi fi-arrow-down-full fs11px"></i>
              </a>
            </div>

            <div
              v-if="
                loginState == 'enterWithOTP' || loginState == 'enterWithPass'
              "
              class="mt-2 p-1 fs11px text-center"
            >
              <span class="text-primary"
                >ورود شما به معنای پذیرش
                <span class="text-danger pointer" @click="privacyRuleClick"
                  >شرایط ارگانیک مایندد و قوانین حریم خصوصی</span
                >
                است</span
              >
            </div>

            <div class="collapse text-secondary" id="collapseExample">
              <div class="border-2 border-end me-2 p-2 fs13px">
                <div class="pt-2">
                  <i class="fi fi-envelope-2 ms-2"></i>ایمیل:
                  <a
                    href="mail:support@organicminded.org"
                    class="text-dashed fs13px support-link"
                  >
                    support@organicminded.org</a
                  >
                </div>
                <div class="pt-2">
                  <svg
                    width="14px"
                    height="14px"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    class="bi bi-telephone-inbound-fill ms-1"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511zM15.854.146a.5.5 0 0 1 0 .708L11.707 5H14.5a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 1 0v2.793L15.146.146a.5.5 0 0 1 .708 0z"
                    ></path>
                  </svg>
                  شماره تلفن:
                  <a
                    href="tel:۰۲۱-۹۱۰۰۵۱۴۱"
                    class="fs13px text-dashed support-link"
                    dir="ltr"
                    >۰۲۱-۹۱۰۰۵۱۴۱</a
                  >
                </div>

                <div class="pt-2">
                  <svg
                    width="14px"
                    height="14px"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    class="bi bi-question-circle-fill ms-2"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.496 6.033h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286a.237.237 0 0 0 .241.247zm2.325 6.443c.61 0 1.029-.394 1.029-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94 0 .533.425.927 1.01.927z"
                    ></path>
                  </svg>

                  <a href="/faq" class="fs13px text-dashed support-link"
                    >پرسش های متداول</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- //------------------------------------------------------------------------------------------ -->
    <div class="section pt-1 my-1" v-if="status == 'forgetpassword'">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-sm-8 col-md-8 col-lg-5">
            <div id="" class="rounded border shadow-xs p-2">
              <!-- <div class="px-4">
                <h6 class="text-center py-2">رمز عبورم را فراموش کرده ام</h6>
                <hr class="hr-right" />
              </div> -->

              <validation-summery
                v-if="resetPassHasError"
                :errors="resetPassError"
              ></validation-summery>

              <!----------------------------------------------------------------------------------------------------\\ -->
              <div
                class="card"
                v-if="resetPasswordState == 'verifyCodeForResetPassword'"
              >
                <p class="text-center my-2">
                  کد اعتبار سنجی ارسال شده را وارد نمایید
                </p>
                <div class="card-body p-2">
                  <div dir="ltr">
                    <code-input
                      ref="confirmationCodeInput"
                      id="confirmationCodeInput"
                      @complete="onForgetPasswordCodeComplete"
                      :fields="6"
                      :fieldWidth="isMobile ? 42 : 56"
                      :fieldHeight="isMobile ? 42 : 56"
                      :required="true"
                      title=""
                      errorMessage="وارد کردن کد اعتبار سنجی الزامی است"
                      erroMessageClass="px-4 smaller text-danger"
                      titleClass="pe-3"
                    />
                  </div>

                  <!-- <floating-input-with-message
                    containerClass="mb-3"
                    inputType="intNumber"
                    ID="confirmationCodeForResetPassword"
                    ref="confirmationCodeForResetPassword"
                    inputPlaceHolder="confirmationCodeForResetPassword"
                    v-model:inputValue="verifyCodeForResetPassEntity.token"
                    labelClass="text-muted small"
                    labelValue="کد اعتبار سنجی"
                    errorMessage="وارد کردن کد اعتبار سنجی الزامی است"
                    erroMessageClass="smaller text-danger"
                  /> -->
                  <div class="row mt-3">
                    <div class="col-6">
                      <button
                        type="submit"
                        class="btn btn-orangeSite w-100"
                        @click="confirmingCodeForResetPassword"
                      >
                        <i class="fi fi-box-checked"></i>
                        ثبت
                      </button>
                    </div>
                    <div class="col-6">
                      <div class="text-center">
                        <button
                          class="btn btn-orangeSite w-100"
                          :disabled="resetPassCodeCounting"
                          @click="resetPassShowClick"
                        >
                          <vue-countdown
                            v-if="resetPassCodeCounting"
                            :time="125000"
                            @end="onResetPassCountdownEnd"
                            v-slot="{ minutes, seconds }"
                            :transform="transformSlotProps"
                          >
                            {{ minutes }}:{{ seconds }}
                          </vue-countdown>
                          <span v-else>ارسال کد</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!----------------------------------------------------------------------------------------------------\\ -->
              <div class="card" v-if="resetPasswordState == 'resetPassword'">
                <div class="card-body p-2">
                  <div class="form-floating mb-3">
                    <floating-input-with-message
                      containerClass="mb-3"
                      inputType="password"
                      ref="newPassInput"
                      inputPlaceHolder="کلمه عبور جدید"
                      v-model:inputValue="resetPasswordEntity.newPassword"
                      labelClass="text-muted small"
                      labelValue="کلمه عبور جدید"
                      errorMessage="وارد کردن کلمه عبور جدید الزامی است"
                      erroMessageClass="smaller text-danger"
                    />
                  </div>
                  <div class="form-floating mb-3">
                    <floating-input-with-message
                      containerClass="mb-3"
                      inputType="password"
                      ref="newConfirmPassInput"
                      inputPlaceHolder="تکرار کلمه عبور جدید"
                      v-model:inputValue="
                        resetPasswordEntity.confirmNewPassword
                      "
                      labelClass="text-muted small"
                      labelValue="تکرار کلمه عبور جدید"
                      errorMessage="تکرار کلمه عبور الزامی و می بایست مشابه کلمه عبور جدید باشد"
                      erroMessageClass="smaller text-danger"
                    />
                  </div>
                  <p class="smaller text-danger-gradient mb-4 justified">
                    <i class="fi fi-round-info-full"></i> کلمه عبور می بایست
                    حداقل 6 کارکتر و حاوی کارکتر های فارسی نباشد. در ضمن کلمه
                    عبور می بایست حداقل حاوی یک حرف کوچک، بزرگ و عدد باشد
                  </p>
                  <button
                    type="submit"
                    class="btn btn-orangeSite w-100 mt-3"
                    @click="changePasswordButtonClick"
                  >
                    <i class="fi fi-box-checked"></i>
                    ثبت
                  </button>
                </div>
              </div>
              <div class="mt-3" id="returnResetDiv">
                <p class="px-4">
                  <a
                    href="#"
                    class="text-decoration-none link-muted fs13px"
                    @click="resetPassReturnButtonClick"
                    ><i class="fi fi-arrow-right"></i>
                    بازگشت
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section pt-1 my-1" v-if="status == 'signup'">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-sm-8 col-md-8 col-lg-5">
            <div class="rounded border shadow-xs p-1">
              <!-- ........................... Signup Form............................... -->
              <div v-if="signupState == 'signup'">
                <p class="text-center alert alert-success">
                  برای ثبت نام، لطفا اطلاعات زیر را
                  {{
                    signupClientModel.clientsInfo[0].isNew ? 'تکمیل' : 'تایید'
                  }}

                  نمایید
                </p>
                <!-- <div class="px-4">
                  <h6
                    class="text-center py-2"
                    :class="isMobile ? 'fs13px' : ''"
                  >
                    برای ثبت نام، لطفا اطلاعات زیر را
                    {{
                      signupClientModel.clientsInfo[0].isNew ? 'تکمیل' : 'تایید'
                    }}

                    نمایید
                  </h6>
                  <hr class="hr-right" />
                </div> -->

                <validation-summery
                  v-if="signupHasError"
                  :errors="signupError"
                ></validation-summery>

                <div class="card">
                  <div class="card-body p-2">
                    <div class="row justify-content-center">
                      <div class="col-10">
                        <input-with-message
                          ref="phoneEmailInput"
                          containerClass="mb-1"
                          errorMessage="وارد کردن مقدار موبایل | ایمیل الزامی است"
                          erroMessageClass="text-danger smaller"
                          topTitle="موبایل | ایمیل:"
                          :required="true"
                          :iconSpin="false"
                          inputType="text"
                          :showMessage="false"
                          :hasLeftBox="false"
                          :showIcon="false"
                          :hasSideBox="false"
                          topTitleClass="mb-1"
                          v-model:inputValue="signupClientModel.username"
                          :disableInput="1 == 1"
                        />

                        <input-with-message
                          ref="firstNameInput"
                          containerClass="mb-1"
                          errorMessage="وارد کردن مقدار نام الزامی است"
                          erroMessageClass="text-danger smaller"
                          topTitle="نام:"
                          :required="true"
                          :iconSpin="false"
                          inputType="text"
                          :showMessage="false"
                          :hasLeftBox="false"
                          :showIcon="false"
                          :hasSideBox="false"
                          topTitleClass="mb-1"
                          :disableInput="
                            !signupClientModel.clientsInfo[0].isNew
                          "
                          v-model:inputValue="
                            signupClientModel.clientsInfo[0].firstName
                          "
                          v-if="signupClientModel.clientsInfo.length == 1"
                        />
                        <input-with-message
                          ref="lastNameInput"
                          containerClass="mb-1"
                          errorMessage="وارد کردن مقدار نام خانوادگی الزامی است"
                          erroMessageClass="text-danger smaller"
                          topTitle="نام خانوادگی:"
                          :required="true"
                          :iconSpin="false"
                          inputType="text"
                          :showMessage="false"
                          :disableInput="
                            !signupClientModel.clientsInfo[0].isNew
                          "
                          :hasLeftBox="false"
                          :showIcon="false"
                          :hasSideBox="false"
                          topTitleClass="mb-1"
                          v-model:inputValue="
                            signupClientModel.clientsInfo[0].lastName
                          "
                          v-if="signupClientModel.clientsInfo.length == 1"
                        />
                      </div>
                    </div>

                    <!-- Multiple Clinet -->
                    <div
                      class="card my-1 shadow"
                      id="mutlipleClientCard"
                      v-if="signupClientModel.clientsInfo.length > 1"
                    >
                      <div class="mb-2">
                        <p class="px-4 mt-2 py-0 mb-0">
                          <svg
                            width="18px"
                            height="18px"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentColor"
                            class="bi bi-person-fill"
                            viewBox="0 0 16 16"
                          >
                            <path
                              d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
                            ></path>
                          </svg>
                          مشخصات مراجعان:
                        </p>
                      </div>
                      <div class="row g-3 p-2">
                        <div
                          class="col-6 col-md-6 col-sm-6 col-lg-4"
                          v-for="item in signupClientModel.clientsInfo"
                          :key="item.id"
                        >
                          <div
                            class="card shadow text-center bg-gray-200 fs14px"
                          >
                            <div class="card-body">
                              <svg
                                width="30px"
                                height="30px"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="currentColor"
                                class="bi bi-person-check"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H1s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C9.516 10.68 8.289 10 6 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z"
                                ></path>
                                <path
                                  fill-rule="evenodd"
                                  d="M15.854 5.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L12.5 7.793l2.646-2.647a.5.5 0 0 1 .708 0z"
                                ></path>
                              </svg>
                              <div>
                                {{ item.firstName }} {{ item.lastName }}
                              </div>
                              <div title="شماره عضویت" class="pointer">
                                {{ item.clientCode }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Multiple Clinet -->

                    <button
                      type="submit"
                      class="btn btn-blueSite w-100 mt-3"
                      @click="signupClick"
                    >
                      {{
                        !signupClientModel.clientsInfo[0].isNew
                          ? 'تایید'
                          : 'ثبت نام'
                      }}
                    </button>
                  </div>
                </div>
              </div>
              <!-- ........................... confirmation ............................... -->
              <div v-if="signupState == 'confirmation'">
                <p class="text-center alert alert-success">
                  کد اعتبار سنجی ارسال شده را وارد نمایید
                </p>
                <div class="card">
                  <div class="card-body p-2">
                    <div dir="ltr">
                      <code-input
                        ref="confirmationCodeInput"
                        id="confirmationCodeInput"
                        @complete="onSignupCodeComplete"
                        :fields="6"
                        :fieldWidth="isMobile ? 42 : 56"
                        :fieldHeight="isMobile ? 42 : 56"
                        :required="true"
                        title=""
                        titleClass="pe-3"
                        errorMessage="وارد کردن کد اعتبار سنجی الزامی است"
                        erroMessageClass="px-4 smaller text-danger"
                      />
                    </div>

                    <!-- <floating-input-with-message
                      containerClass="mb-3"
                      inputType="intNumber"
                      ID="confirmationCodeForSignup"
                      ref="confirmationCodeForSignup"
                      v-model:inputValue="verifyCodeForSignupEntity.token"
                      labelClass="text-muted small"
                      labelValue="کد اعتبار سنجی"
                      errorMessage="وارد کردن کد اعتبار سنجی الزامی است"
                      erroMessageClass="smaller text-danger"
                    /> -->
                    <div class="row mt-3">
                      <div class="col-6">
                        <button
                          type="submit"
                          class="btn btn-blueSite w-100"
                          @click="confirmingCodeForSignup"
                        >
                          <i class="fi fi-box-checked"></i>
                          ثبت
                        </button>
                      </div>
                      <div class="col-6">
                        <div class="text-center">
                          <button
                            class="btn btn-blueSite w-100"
                            :disabled="signupCodeCounting"
                            @click="resendVerficationCodeForSignup"
                          >
                            <vue-countdown
                              v-if="signupCodeCounting"
                              :time="125000"
                              @end="onSignupCountdownEnd"
                              v-slot="{ minutes, seconds }"
                              :transform="transformSlotProps"
                            >
                              {{ minutes }}:{{ seconds }}
                            </vue-countdown>
                            <span v-else>ارسال کد</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-3">
                <p class="px-4">
                  <a
                    href="#"
                    class="text-decoration-none link-muted fs13px"
                    @click="signupReturnButtonClick"
                    ><i class="fi fi-arrow-right"></i>
                    بازگشت
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LoadingSpinner from '../../components/utility/loadingSpinner/LoadingSpinner.vue';
import { isMobile } from 'mobile-device-detect';
import FloatingInputWithMessage from '../../components/form/floatingInputWithMessage/FloatingInputWithMessage.vue';
import InputWithMessage from '../../components/form/inputWithMessage/InputWithMessage.vue';
import axios from 'axios';
import VueCountdown from '@chenfengyuan/vue-countdown';
import ValidationSummery from '../../components/form/errorBox/ValidationSummery.vue';
import { Modal } from 'bootstrap';
import Captcha from '../../components/utility/captcha/Captcha.vue';
import CodeInput from '../../components/utility/codeInput/CodeInput.vue';
// import VOtpInput from 'vue3-otp-input';
export default {
  components: {
    LoadingSpinner,
    FloatingInputWithMessage,
    InputWithMessage,
    VueCountdown,
    ValidationSummery,
    Captcha,
    CodeInput,
    // VOtpInput,
  },
  data() {
    return {
      isMobile: isMobile,
      status: 'login',
      otpCompleted: false,
      chooseClientModal: new Object(),
      privacyModal: new Object(),
      signupHasError: false,
      signupError: [],
      abortController: null,

      resetPassHasError: false,
      resetPassCodeCounting: true,
      signupCodeCounting: true,
      otpCounting: true,
      loginResponseViewModel: null,
      signupClientModel: null,
      resetPassError: [],
      failLogin: 0,
      radioSignupPhoneEmail: 'phone',
      radiologinPhoneEmail: 'phone',
      resetPasswordState: 'verifyCodeForResetPassword',
      loginState: 'enterPhoneEmail', // enterPhoneEmail | chooseLoginMethod | enterWithOTP | enterWithPass
      signupState: 'confirmation', // 'confirmation' , 'signup'
      entity: {
        password: null,
        username: null,
        rememberMe: false,
        callFromSite: true,
      },
      verifyCodeForResetPassEntity: {
        phoneEmail: null,
        token: null,
      },
      verifyCodeForSignupEntity: {
        phoneEmail: null,
        token: null,
      },

      verifyOTPForLoginEntity: {
        phoneEmail: null,
        token: null,
      },
      checkPhoneEmailForLoginEntity: {
        phoneEmail: null,
      },
      resetPasswordEntity: {
        phoneEmail: null,
        newPassword: null,
        confirmNewPassword: null,
        resetPasswordToken: null,
      },

      resetPassPhoneEmail: {
        phoen: '',
        email: '',
      },
    };
  },
  methods: {
    loginRadioClick(e) {
      if (e.target.id == 'loginRadioPhone') {
        this.radiologinPhoneEmail = 'phone';
      }
      if (e.target.id == 'loginRadioEmail') {
        this.radiologinPhoneEmail = 'email';
      }
      setTimeout(() => {
        this.$refs.phoneEmailLoginInput?.setFocus();
      }, 0);
      this.checkPhoneEmailForLoginEntity.phoneEmail = null;
    },

    resetPassReturnButtonClick() {
      this.status = 'login';
      this.resetErrors();
      this.resetPasswordEntity = new Object({
        phoneEmail: null,
        newPassword: null,
        confirmNewPassword: null,
        resetPasswordToken: null,
      });
      this.verifyCodeForResetPassEntity = new Object({
        phoneEmail: null,
        token: null,
      });
      setTimeout(() => {
        this.$refs?.login_password?.setFocus();
      }, 0);
    },
    validatePhoneEmail(input) {
      // eslint-disable-next-line
      input = fixNumbers(input);
      let result = false;
      // eslint-disable-next-line
      result = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(input);
      if (!result) {
        // eslint-disable-next-line
        result = /^09\d{9}$/.test(input);
      }
      return result;
    },
    onResetPassCountdownEnd: function () {
      this.resetPassCodeCounting = false;
    },
    onOTPCountdownEnd: function () {
      this.otpCounting = false;
    },
    onSignupCountdownEnd: function () {
      this.signupCodeCounting = false;
    },
    async onOtpComplete(isCompelete, val) {
      if (isCompelete) {
        this.verifyOTPForLoginEntity.token = val;
        await this.verifyOTPForLogin();
      } else {
        this.verifyOTPForLoginEntity.token = null;
      }
    },
    async onSignupCodeComplete(isCompelete, val) {
      if (isCompelete) {
        this.verifyCodeForSignupEntity.token = val;
        await this.confirmingCodeForSignup();
      } else {
        this.verifyCodeForSignupEntity.token = null;
      }
    },
    async onForgetPasswordCodeComplete(isCompelete, val) {
      if (isCompelete) {
        this.verifyCodeForResetPassEntity.token = val;
        await this.confirmingCodeForResetPassword();
      } else {
        this.verifyCodeForResetPassEntity.token = null;
      }
    },

    resetErrors() {
      this.resetPassHasError = false;
      this.resetPassError = [];
    },
    transformSlotProps(props) {
      const formattedProps = {};
      Object.entries(props).forEach(([key, value]) => {
        formattedProps[key] = value < 10 ? `0${value}` : String(value);
      });
      return formattedProps;
    },
    loginReturnButtonClick() {
      if (this.loginState == 'chooseLoginMethod') {
        this.loginState = 'enterPhoneEmail';
      }
      if (
        this.loginState == 'enterWithOTP' ||
        this.loginState == 'enterWithPass'
      ) {
        this.loginState = 'chooseLoginMethod';
      }
    },
    passClient() {
      if (this.$store.getters.userFullName) {
        this.$refs.notification.show({
          type: 'success',
          title: `${this.$store.getters.userFullName} خوش آمدید `,
        });
        this.$store.dispatch('loadConfiguration');

        //----------------بررسی فیلتر ثبت جلسه تست
        let filterForPreTestReserving =
          this.$store.getters.getFilterForPreTestReserving;
        if (filterForPreTestReserving) {
          if (
            filterForPreTestReserving.testTypeID != 0 &&
            filterForPreTestReserving.sessionTypeID != 0 &&
            filterForPreTestReserving.sessionTypeID != null
          ) {
            this.$router.push({
              name: 'reservingSessionTab',
              params: { id: this.$store.getters.userPersonID },
            });

            this.$router.options.history.state.back = 'selectTestSession';
            return;
          }
        }
        //----------------بررسی فیلتر ثبت جلسه
        let filterForPreReserving =
          this.$store.getters.getFilterForPreReserving;
        if (filterForPreReserving) {
          if (
            filterForPreReserving.therapyTypeID != 0 &&
            filterForPreReserving.therapyTypeID != null &&
            filterForPreReserving.sessionTypeID != 0 &&
            filterForPreReserving.sessionTypeID != null &&
            ((filterForPreReserving.therapyTypeID == 1 &&
              filterForPreReserving.scopeIDs.length != 0) ||
              filterForPreReserving.therapyTypeID != 1)
          ) {
            this.$router.push({
              name: 'reservingSessionTab',
              params: { id: this.$store.getters.userPersonID },
            });
            return;
          }
        }
        this.$router.push({
          name: 'userPanel',
          params: { id: this.$store.getters.userPersonID },
        });
      }
    },

    enterWithPassClick() {
      this.loginState = 'enterWithPass';
      setTimeout(() => {
        this.$refs?.login_password?.setFocus();
      }, 0);
    },
    validateLogin() {
      if (!this.entity.password) {
        this.$refs.login_password.showErrorMessage();
        this.$refs.login_password.setFocus();
        return false;
      }
      if (this.failLogin >= 3) {
        return this.$refs.captchaComp.validateCaptcha();
      }
      return true;
    },
    signupReturnButtonClick() {
      this.status = 'login';
      this.signupState = 'confirmation';
      this.signupClientModel = null;
      this.verifyCodeForSignupEntity = new Object({
        phoneEmail: null,
        token: null,
      });
    },
    validateSignUp() {
      // New Client and User
      if (
        this.signupClientModel.clientsInfo.length == 1 &&
        this.signupClientModel.clientsInfo[0]?.isNew
      ) {
        if (!this.signupClientModel.clientsInfo[0].firstName) {
          this.$refs.firstNameInput.showErrorMessage();
          this.$refs.firstNameInput.setFocus();
          return false;
        }
        if (!this.signupClientModel.clientsInfo[0].lastName) {
          this.$refs.lastNameInput.showErrorMessage();
          this.$refs.lastNameInput.setFocus();
          return false;
        }
      }
      return true;
    },

    optCridential() {
      let that = this;

      if ('OTPCredential' in window) {
        that.abortController = new AbortController();
        navigator.credentials
          .get({
            otp: { transport: ['sms'] },
            signal: that.abortController.signal,
          })
          .then((otp) => {
            that.$refs.confirmationCodeInput?.setValue(otp.code);
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },

    async resetPassShowClick() {
      let that = this;
      that.resetErrors();

      this.$refs.spinner.show();
      await axios
        .post(
          '/Security/Account/CheckPhoneEmailForResetPassword',
          that.checkPhoneEmailForLoginEntity
        )
        .then((response) => {
          if (!response?.data?.success) {
            let errorMessages = response.data.errors.map((i) => i.errorMessage);
            errorMessages.forEach((item) => {
              this.$refs.notification.show({
                type: 'error',
                title: item,
              });
            });
            that.resetPassHasError = true;
            that.resetPassError = errorMessages;
            return;
          }
          that.$refs.spinner.hide();
          this.status = 'forgetpassword';
          that.resetPasswordState = 'verifyCodeForResetPassword';
          that.resetPassCodeCounting = true;
          setTimeout(() => {
            that.$refs?.confirmationCodeInput?.setFocus();
          }, 0);
        })
        .catch((error) => {
          if (!error.response.data.success) {
            let errorMessages = error.response.data.errors.map(
              (i) => i.errorMessage
            );
            errorMessages.forEach((item) => {
              that.$refs.notification.show({
                type: 'error',
                title: item,
              });
            });
            if (errorMessages && errorMessages.length > 0) return;
          }
          this.$refs.notification.show({
            type: 'error',
            title: `عملیات مورد نظر با خطا مواجه گردید`,
          });
        })
        .finally(() => {
          this.$refs.spinner.hide();
        });
    },

    async resendOTPClick() {
      this.otpCounting = true;
      await this.enterWithOTPClick();
    },
    async resendVerficationCodeForSignup() {
      this.signupCodeCounting = true;
      await this.checkPhoneEmailLoginClick();
    },
    async confirmingCodeForSignup() {
      if (!this.verifyCodeForSignupEntity.token) {
        this.$refs.confirmationCodeInput.showErrorMessage();
        this.$refs.confirmationCodeInput.setFocus();
        return;
      }
      let that = this;

      // eslint-disable-next-line
      that.verifyCodeForSignupEntity.token = fixNumbers(
        that.verifyCodeForSignupEntity.token
      );

      that.verifyCodeForSignupEntity.phoneEmail =
        that.checkPhoneEmailForLoginEntity.phoneEmail;

      this.$refs.spinner.show();
      await axios
        .post(
          '/Basic/Client/ValidateConfirmationCodeForSignup',
          that.verifyCodeForSignupEntity
        )
        .then((response) => {
          if (!response?.data?.success) {
            let errorMessages = response.data.errors.map((i) => i.errorMessage);
            errorMessages.forEach((item) => {
              this.$refs.notification.show({
                type: 'error',
                title: item,
              });
            });
            return;
          }
          if (response?.data?.returnValue) {
            that.signupClientModel = response.data.returnValue;
          }
          that.signupState = 'signup';
          that.$refs.spinner.hide();
        })
        .catch((error) => {
          if (!error.response.data.success) {
            let errorMessages = error.response.data.errors.map(
              (i) => i.errorMessage
            );
            errorMessages.forEach((item) => {
              that.$refs.notification.show({
                type: 'error',
                title: item,
              });
            });
            if (errorMessages && errorMessages.length > 0) return;
          }
          this.$refs.notification.show({
            type: 'error',
            title: `عملیات مورد نظر با خطا مواجه گردید`,
          });
        })
        .finally(() => {
          this.$refs.spinner.hide();
        });
    },

    async enterWithOTPClick() {
      let that = this;
      that.$refs.spinner.show();
      await axios
        .post(
          '/Security/Account/SendOTPForLogin',
          that.checkPhoneEmailForLoginEntity
        )
        .then((response) => {
          if (!response?.data?.success) {
            let errorMessages = response.data.errors.map((i) => i.errorMessage);
            errorMessages.forEach((item) => {
              this.$refs.notification.show({
                type: 'error',
                title: item,
              });
            });
            return;
          }

          that.$refs.spinner.hide();
          that.loginState = 'enterWithOTP';
          that.otpCounting = true;

          setTimeout(() => {
            that.$refs?.confirmationCodeInput?.setFocus();
          }, 0);
        })
        .catch((error) => {
          if (!error.response.data.success) {
            let errorMessages = error.response.data.errors.map(
              (i) => i.errorMessage
            );
            errorMessages.forEach((item) => {
              that.$refs.notification.show({
                type: 'error',
                title: item,
              });
            });
            if (errorMessages && errorMessages.length > 0) return;
          }
          this.$refs.notification.show({
            type: 'error',
            title: `عملیات مورد نظر با خطا مواجه گردید`,
          });
        })
        .finally(() => {
          this.$refs.spinner.hide();
        });
    },

    async verifyOTPForLogin() {
      if (!this.verifyOTPForLoginEntity.token) {
        this.$refs.confirmationCodeInput.showErrorMessage();
        this.$refs.confirmationCodeInput.setFocus();
        return;
      }

      let that = this;
      that.$refs.spinner.show();
      // eslint-disable-next-line
      that.verifyOTPForLoginEntity.token = fixNumbers(
        that.verifyOTPForLoginEntity.token
      );
      that.verifyOTPForLoginEntity.phoneEmail =
        that.checkPhoneEmailForLoginEntity.phoneEmail;
      that.$store
        .dispatch('loginWithOTP', that.verifyOTPForLoginEntity)
        .then(() => {
          that.passClient();
        })
        .catch((error) => {
          that.$refs.spinner.hide();
          if (error === 'TwoFactorAuthentication') {
            that.$refs.notification.show({
              type: 'error',
              title: `با توجه به تنظیمات سیستم، امکان ورود با رمز یکبار مصرف برای شما وجود ندارد`,
            });
            return;
          } else if (error.data && error.data?.clients?.length > 1) {
            that.loginResponseViewModel = error.data;
            // Modal to choose client
            that.chooseClientModal.show();
            that.$store.dispatch(
              'setClientList',
              that.loginResponseViewModel.clients
            );
          } else if (
            error.data &&
            error.data.errors &&
            error.data.errors?.length > 0
          ) {
            // if (error.response.status != 403) {
            //   that.failLogin += 1;
            //   if (that.failLogin >= 3) {
            //     // that.$refs.captchaComp.refreshButtonClick();
            //   }
            // }
            if (!error.data.success) {
              let errorMessages = error.data.errors.map((i) => i.errorMessage);
              errorMessages.forEach((item) => {
                that.$refs.notification.show({
                  type: 'error',
                  title: item,
                });
              });
            }
          } else if (error.data && error.data.success === false) {
            that.$refs.notification.show({
              type: 'warning',
              title: `در برقراری ارتباط با سامانه مشکل ای به وجود آمده است`,
            });
          } else if (error.response.status !== 429) {
            that.$refs.notification.show({
              type: 'warning',
              title: `در برقراری ارتباط با سامانه مشکل ای به وجود آمده است`,
            });
          }
        })
        .finally(() => {
          that.$refs.spinner.hide();
        });
    },

    async confirmingCodeForResetPassword() {
      if (!this.verifyCodeForResetPassEntity.token) {
        this.$refs.confirmationCodeInput.showErrorMessage();
        this.$refs.confirmationCodeInput.setFocus();
        return;
      }
      this.resetErrors();
      let that = this;
      that.$refs.spinner.show();

      that.verifyCodeForResetPassEntity.phoneEmail =
        that.checkPhoneEmailForLoginEntity.phoneEmail;
      // eslint-disable-next-line
      that.verifyCodeForResetPassEntity.token = fixNumbers(
        that.verifyCodeForResetPassEntity.token.trim()
      );

      await axios
        .post(
          '/Security/Account/ValidateConfirmationCodeForResetPassword',
          that.verifyCodeForResetPassEntity
        )
        .then((response) => {
          if (!response?.data?.success) {
            let errorMessages = response.data.errors.map((i) => i.errorMessage);
            errorMessages.forEach((item) => {
              this.$refs.notification.show({
                type: 'error',
                title: item,
              });
            });
            that.resetPassHasError = true;
            that.resetPassError = errorMessages;
            return;
          }
          if (response?.data?.returnValue) {
            that.resetPasswordEntity.resetPasswordToken =
              response?.data?.returnValue;
          }

          that.$refs.spinner.hide();
          that.resetPasswordState = 'resetPassword';
        })
        .catch((error) => {
          if (!error.response.data.success) {
            let errorMessages = error.response.data.errors.map(
              (i) => i.errorMessage
            );
            errorMessages.forEach((item) => {
              that.$refs.notification.show({
                type: 'error',
                title: item,
              });
            });
            if (errorMessages && errorMessages.length > 0) return;
          }
          this.$refs.notification.show({
            type: 'error',
            title: `عملیات مورد نظر با خطا مواجه گردید`,
          });
        })
        .finally(() => {
          this.$refs.spinner.hide();
        });
    },
    async changePasswordButtonClick() {
      if (!this.resetPasswordEntity.newPassword) {
        this.$refs.newPassInput.showErrorMessage();
        this.$refs.newPassInput.setFocus();
        return;
      }
      if (!this.resetPasswordEntity.confirmNewPassword) {
        this.$refs.newConfirmPassInput.showErrorMessage();
        this.$refs.newConfirmPassInput.setFocus();
        return;
      }
      if (
        this.resetPasswordEntity.newPassword !==
        this.resetPasswordEntity.confirmNewPassword
      ) {
        this.$refs.newConfirmPassInput.showErrorMessage();
        this.$refs.newConfirmPassInput.setFocus();
        return;
      }
      let that = this;

      that.resetPasswordEntity.phoneEmail =
        that.checkPhoneEmailForLoginEntity.phoneEmail;

      that.$refs.spinner.show();

      await axios
        .post(
          '/Security/Account/ResetPasswordForSite',
          that.resetPasswordEntity
        )
        .then((response) => {
          if (!response?.data?.success) {
            let errorMessages = response.data.errors.map((i) => i.errorMessage);
            errorMessages.forEach((item) => {
              this.$refs.notification.show({
                type: 'error',
                title: item,
              });
            });
            that.resetPassHasError = true;
            that.resetPassError = errorMessages;
            return;
          }
          that.$refs.notification.show({
            type: 'success',
            title: 'کلمه عبور با موفقیت تغییر یافت',
          });
          that.$refs.spinner.hide();
          window.location.reload();
        })
        .catch((error) => {
          if (!error.response.data.success) {
            let errorMessages = error.response.data.errors.map(
              (i) => i.errorMessage
            );
            errorMessages.forEach((item) => {
              that.$refs.notification.show({
                type: 'error',
                title: item,
              });
            });
            if (errorMessages && errorMessages.length > 0) return;
          }
          this.$refs.notification.show({
            type: 'error',
            title: `عملیات مورد نظر با خطا مواجه گردید`,
          });
        })
        .finally(() => {
          this.$refs.spinner.hide();
        });
    },
    async checkPhoneEmailLoginClick() {
      if (!this.checkPhoneEmailForLoginEntity.phoneEmail) {
        this.$refs.phoneEmailLoginInput.showErrorMessage();
        this.$refs.phoneEmailLoginInput.setFocus();
        return;
      }
      if (
        !this.validatePhoneEmail(this.checkPhoneEmailForLoginEntity.phoneEmail)
      ) {
        this.$refs.notification.show({
          type: 'error',
          title: `شماره موبایل یا ایمیل خود را به درستی وارد نمایید`,
        });
        return;
      }

      let that = this;

      this.$refs.spinner.show();
      await axios
        .post(
          '/Security/Account/CheckPhoneEmailForLogin',
          that.checkPhoneEmailForLoginEntity
        )
        .then(async (response) => {
          if (!response?.data?.success) {
            let errorMessages = response.data.errors.map((i) => i.errorMessage);
            errorMessages.forEach((item) => {
              this.$refs.notification.show({
                type: 'error',
                title: item,
              });
            });
            return;
          }
          that.$refs.spinner.hide();
          let result = response.data.returnValue;
          if (result) {
            that.loginState = 'chooseLoginMethod';
          }
          //go to register process
          else {
            that.signupState = 'confirmation';
            that.status = 'signup';
            setTimeout(() => {
              that.$refs?.confirmationCodeInput?.setFocus();
            }, 0);
          }
        })
        .catch((error) => {
          if (!error.response.data.success) {
            let errorMessages = error.response.data.errors.map(
              (i) => i.errorMessage
            );
            errorMessages.forEach((item) => {
              that.$refs.notification.show({
                type: 'error',
                title: item,
              });
            });
            if (errorMessages && errorMessages.length > 0) return;
          }
          this.$refs.notification.show({
            type: 'error',
            title: `عملیات مورد نظر با خطا مواجه گردید`,
          });
        })
        .finally(() => {
          this.$refs.spinner.hide();
        });
    },
    async chooseClientButtonClick(item) {
      this.$refs.spinner.show();
      let that = this;
      this.$store
        .dispatch('setStorageAndSetterItems', {
          token: that.loginResponseViewModel.token,
          refreshToken: that.loginResponseViewModel.refreshToken,
          userID: that.loginResponseViewModel.userID,
          firstName: item.firstName,
          lastName: item.lastName,
          requireChangePassword:
            that.loginResponseViewModel.requireChangePassword,
          userName: that.loginResponseViewModel.userName,
          lastLoginDateTime: that.loginResponseViewModel.lastLoginDateTime,
          isPartTime: item.isPartTime,
          personID: item.personID,
          hasUnseenMessage: item.hasUnseenMessage,
        })
        .then(() => {
          that.$refs.spinner.hide();
          that.chooseClientModal.hide();
          that.passClient();
        })
        .catch(() => {
          that.$refs.spinner.hide();
        });
    },

    async login() {
      let that = this;
      this.entity.username = that.checkPhoneEmailForLoginEntity.phoneEmail;
      if (!this.validateLogin()) {
        return;
      }

      that.$refs.spinner.show();
      // eslint-disable-next-line
      that.entity.username = fixNumbers(that.$data.entity.username);

      that.$store
        .dispatch('login', that.entity)
        .then(() => {
          that.passClient();
        })
        .catch((error) => {
          that.$refs.spinner.hide();
          if (error === 'TwoFactorAuthentication') {
            that.twoFactorEntity.twoFactorCode = '';
            that.counting = true;
            that.confirmationCodeModal.show();
            that.$refs.twoFactorConfirmationCode.focus();
          } else if (error.data && error.data?.clients?.length > 1) {
            that.loginResponseViewModel = error.data;
            // Modal to choose client
            that.chooseClientModal.show();
            that.$store.dispatch(
              'setClientList',
              that.loginResponseViewModel.clients
            );
          } else if (
            error.response &&
            error.response.data.errors &&
            error.response.data.errors?.length > 0
          ) {
            if (error.response.status != 403) {
              that.failLogin += 1;
              if (that.failLogin >= 3) {
                that.$refs.captchaComp.refreshButtonClick();
              }
            }
            if (!error.response.data.success) {
              let errorMessages = error.response.data.errors.map(
                (i) => i.errorMessage
              );
              errorMessages.forEach((item) => {
                that.$refs.notification.show({
                  type: 'error',
                  title: item,
                });
              });
            }
          } else if (error.response.status !== 429) {
            that.$refs.notification.show({
              type: 'warning',
              title: `در برقراری ارتباط با سامانه مشکل ای به وجود آمده است`,
            });
          }
        })
        .finally(() => {
          that.$refs.spinner.hide();
        });
    },

    async signupClick() {
      if (!this.validateSignUp()) {
        return;
      }
      let that = this;
      that.$refs.spinner.show();

      await axios
        .post('/Basic/Client/SignupClient', that.signupClientModel)
        .then((response) => {
          if (!response?.data?.success) {
            let errorMessages = response.data.errors.map((i) => i.errorMessage);
            errorMessages.forEach((item) => {
              that.$refs.notification.show({
                type: 'error',
                title: item,
              });
            });
            return;
          }
          that.$refs.spinner.hide();
          that.$refs.notification.show({
            type: 'success',
            title:
              'حساب کاربری با موفقیت ایجاد شد. لطفا با مشخصات کاربری خود وارد سامانه شوید',
          });
          that.status = 'login';
          that.signupClientModel = null;
          // that.$router.push('/login');
          that.$router.push('/login');
          window.location.reload();
        })
        .catch((error) => {
          if (!error.response.data.success) {
            let errorMessages = error.response.data.errors.map(
              (i) => i.errorMessage
            );
            errorMessages.forEach((item) => {
              that.$refs.notification.show({
                type: 'error',
                title: item,
              });
            });
            if (errorMessages && errorMessages.length > 0) return;
          }
          this.$refs.notification.show({
            type: 'error',
            title: `عملیات مورد نظر با خطا مواجه گردید`,
          });
        })
        .finally(() => {
          this.$refs.spinner.hide();
        });
    },
    privacyRuleClick() {
      this.privacyModal.show();
    },
    closePrivacyModal() {
      this.privacyModal.hide();
    },
  },
  async mounted() {
    this.$refs?.phoneEmailLoginInput?.setFocus();
    this.chooseClientModal = new Modal(
      document.getElementById('chooseClientModal'),
      {
        keyboard: false,
        backdrop: 'static',
      }
    );
    this.privacyModal = new Modal(document.getElementById('privacyModal'), {
      keyboard: false,
      backdrop: 'static',
    });

    this.optCridential();
  },
};
</script>
<style scopped>
.support-link {
  color: rgb(191, 115, 0) !important;
}
.form-check-input[type='radio'] {
  float: right;
  margin-left: 5px;
  margin-right: 0;
}
.form-check-input:checked[type='radio'] {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/%3e%3c/svg%3e");
}
</style>
